/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Presets_LabelInputs */

const en_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Export Presets`)
};

const fr_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les préréglages d’export`)
};

const de_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportvoreinstellungen auswählen`)
};

const it_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona Esporta predefiniti`)
};

const ru_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите параметры экспорта`)
};

const es_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar ajustes preestablecidos de exportación`)
};

const zh_cn2_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择导出预设`)
};

const ja_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートプリセットを選択`)
};

const hi_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सपोर्ट प्रीसेट चुनें`)
};

const pt_pt2_batch_subtitle_export_presets_label = /** @type {(inputs: Batch_Subtitle_Export_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione as predefinições de exportação`)
};

/**
* | output |
* | --- |
* | "Select Export Presets" |
*
* @param {Batch_Subtitle_Export_Presets_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_presets_label = /** @type {((inputs?: Batch_Subtitle_Export_Presets_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Presets_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_presets_label(inputs)
	if (locale === "de") return de_batch_subtitle_export_presets_label(inputs)
	if (locale === "it") return it_batch_subtitle_export_presets_label(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_presets_label(inputs)
	if (locale === "es") return es_batch_subtitle_export_presets_label(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_presets_label(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_presets_label(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_presets_label(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_presets_label(inputs)
	return en_batch_subtitle_export_presets_label(inputs)
});